/*!
 * rms-availability.js — inline Booqable availability calendar for Rent My Style
 * Renders availability on the page instead of inside Booqable's popover widget.
 *
 * USAGE (after uploading to Shopify theme assets):
 *   {{ 'rms-availability.js' | asset_url | script_tag }}
 *
 * Then place ONE of these where you want the calendar:
 *   <div class="rms-availability" data-item="919cab7a-793d-4fca-82cc-882bf7852fda"></div>
 *   <div class="rms-availability" data-slug="{{ product.handle }}"></div>
 *   <div class="rms-availability"></div>   <!-- auto-detects slug from the Booqable button on the page -->
 *
 * Optional per-element overrides: data-location, data-quantity, data-token, data-size.
 * When data-size is omitted, the script reads the currently selected size from the
 * Booqable size dropdown (select.bq-variation) and re-resolves when it changes.
 * Global override (set before this script loads):
 *   window.RMS_AVAILABILITY_CONFIG = { token:"...", location:"...", resolverUrl:"..." };
 */
(function () {
  "use strict";

  /* ---- Store-wide config (these are public, store-wide constants) ---- */
  var CONFIG = {
    shop:     "rent-my-style.booqableshop.com",
    token:    "9840e3647a32eca18f5d351f92d7ca96",
    location: "cf3f97c0-3fe0-40d0-a8e4-a350dea3f3c5",
    quantity: "1",
    // Endpoint that maps a Shopify slug -> Booqable item UUID (modes B & C).
    // Expected to return JSON containing the id, e.g. {"item_id":"<uuid>"}.
    // Point this at an endpoint on your existing bso-digital worker.
    resolverUrl: "https://booqable-to-shopify-sync.bso-digital.workers.dev/get-item-id?slug=",
    // Minimum lead time in days from today before an event date can be picked.
    // Covers both pickup (2-day prep, up to 4 with weekend rollback) and delivery (4 days).
    // Override per element via data-min-lead-days.
    minLeadDays: 4
  };
  if (window.RMS_AVAILABILITY_CONFIG) {
    for (var k in window.RMS_AVAILABILITY_CONFIG) {
      if (Object.prototype.hasOwnProperty.call(window.RMS_AVAILABILITY_CONFIG, k)) {
        CONFIG[k] = window.RMS_AVAILABILITY_CONFIG[k];
      }
    }
  }

  var MONTHS = ["January","February","March","April","May","June",
                "July","August","September","October","November","December"];
  var DOW = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  var STYLE_ID = "rms-availability-style";

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = ''
      + '.rms-cal{max-width:380px;border:1px solid #e5e5e5;border-radius:12px;background:#fff;'
      +   'padding:16px;font-family:inherit;color:#111;margin:20px auto 0;}'
      + '.rms-cal__head{display:flex;align-items:center;justify-content:space-between;margin-bottom:12px}'
      + '.rms-cal__title{font-weight:600;font-size:15px}'
      + '.rms-cal__nav{border:1px solid #e5e5e5;background:#fff;width:32px;height:32px;border-radius:8px;'
      +   'cursor:pointer;font-size:16px;line-height:1;display:flex;align-items:center;justify-content:center}'
      + '.rms-cal__nav:hover{background:#f3f3f3}'
      + '.rms-cal__nav:disabled{opacity:.35;cursor:not-allowed}'
      + '.rms-cal__grid{display:grid;grid-template-columns:repeat(7,1fr);gap:4px}'
      + '.rms-cal__dow{text-align:center;font-size:11px;font-weight:600;color:#888;'
      +   'padding:6px 0;text-transform:uppercase}'
      + '.rms-cal__day{aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;'
      +   'border-radius:8px;font-size:13px;border:1px solid transparent}'
      + '.rms-cal__day--other{color:#ccc}'
      + '.rms-cal__day--available{background:rgba(31,157,85,.10);color:#1f9d55;font-weight:600;'
      +   'border-color:rgba(31,157,85,.25);cursor:pointer}'
      + '.rms-cal__day--available:hover{background:rgba(31,157,85,.22);'
      +   'border-color:rgba(31,157,85,.5)}'
      + '.rms-cal__day--selected{background:#1f9d55;color:#fff;border-color:#1f9d55}'
      + '.rms-cal__day--selected:hover{background:#1f9d55}'
      + '.rms-cal__day--unavailable{background:#f5f5f5;color:#bbb;text-decoration:line-through}'
      + '.rms-cal__legend{display:flex;gap:16px;margin-top:14px;font-size:12px;color:#555}'
      + '.rms-cal__dot{display:inline-block;width:10px;height:10px;border-radius:3px;'
      +   'margin-right:6px;vertical-align:-1px}'
      + '.rms-cal__state{padding:24px 0;text-align:center;color:#888;font-size:13px}';
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = css;
    document.head.appendChild(s);
  }

  function bqHeaders() {
    return {
      "Accept": "application/json",
      "x-booqable-store-provider": "Shopify",
      "x-booqable-storefront-token": CONFIG.token
    };
  }

  /* Read the currently selected size from the Booqable size dropdown, if present. */
  function getSelectedSize() {
    var sel = document.querySelector("select.bq-variation, select[name='variation']");
    if (!sel || !sel.options || sel.selectedIndex < 0) return null;
    var opt = sel.options[sel.selectedIndex];
    var text = (opt && opt.textContent || "").trim();
    return text || null;
  }

  /* Resolve the Booqable item UUID for an element (modes A / B / C). */
  function resolveItemId(el) {
    var explicit = el.getAttribute("data-item");
    if (explicit) return Promise.resolve(explicit);

    var slug = el.getAttribute("data-slug");
    if (!slug) {
      var btn = document.querySelector(".booqable-product-button[data-id]");
      if (btn) slug = btn.getAttribute("data-id");
    }
    if (!slug) return Promise.reject(new Error("no data-item, data-slug, or Booqable button found"));

    var url = CONFIG.resolverUrl + encodeURIComponent(slug);
    var size = el.getAttribute("data-size") || getSelectedSize();
    if (size) url += "&size=" + encodeURIComponent(size);

    return fetch(url, { headers: { "Accept": "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("resolver HTTP " + r.status); return r.json(); })
      .then(function (j) {
        var id = j.item_id || j.id || j.itemId || (j.data && (j.data.item_id || j.data.id));
        if (!id) throw new Error("resolver returned no item id");
        return id;
      });
  }

  function Calendar(el, itemId) {
    this.el       = el;
    this.itemId   = itemId;
    this.location = el.getAttribute("data-location") || CONFIG.location;
    this.quantity = el.getAttribute("data-quantity") || CONFIG.quantity;
    this.token    = el.getAttribute("data-token")    || CONFIG.token;
    var leadAttr  = parseInt(el.getAttribute("data-min-lead-days"), 10);
    this.minLeadDays = isNaN(leadAttr) ? CONFIG.minLeadDays : leadAttr;
    this.selected = null;
    var now = new Date();
    this.year  = now.getFullYear();
    this.month = now.getMonth() + 1;
    this.minYM = this.year * 12 + this.month;
    this.cache = {};
    this.render();
    this.load();
  }

  Calendar.prototype.apiUrl = function () {
    return "https://" + CONFIG.shop + "/api/3/item_availabilities"
      + "?filter[year]="              + this.year
      + "&filter[month]="             + this.month
      + "&filter[item_id]="           + encodeURIComponent(this.itemId)
      + "&filter[start_location_id]=" + encodeURIComponent(this.location)
      + "&filter[quantity]="          + encodeURIComponent(this.quantity);
  };

  Calendar.prototype.load = function () {
    var key = this.year + "-" + this.month;
    if (this.cache[key]) { this.render(); return; }
    this.loading = true;
    this.render();
    var self = this;
    fetch(this.apiUrl(), { headers: bqHeaders() })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (json) {
        var map = {};
        (json.data || []).forEach(function (row) {
          var a = row.attributes || {};
          map[a.date] = !!a.available && a.status === "available";
        });
        self.cache[key] = map;
        self.loading = false;
        self.render();
      })
      .catch(function (err) {
        self.loading = false;
        self.error = err.message;
        self.render();
      });
  };

  Calendar.prototype.setItemId = function (id) {
    if (id === this.itemId) return;
    this.itemId = id;
    this.cache = {};
    this.error = null;
    this.load();
  };

  Calendar.prototype.setMinLeadDays = function (n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n === this.minLeadDays) return;
    this.minLeadDays = n;
    this.render();
  };

  Calendar.prototype.step = function (delta) {
    var ym = this.year * 12 + (this.month - 1) + delta;
    if ((ym + 1) < this.minYM) return;
    this.year  = Math.floor(ym / 12);
    this.month = (ym % 12) + 1;
    this.error = null;
    this.load();
  };

  Calendar.prototype.render = function () {
    var self = this;
    var key  = this.year + "-" + this.month;
    var data = this.cache[key];
    var atMin = (this.year * 12 + this.month) <= this.minYM;

    var html = ''
      + '<div class="rms-cal">'
      +   '<div class="rms-cal__head">'
      +     '<button class="rms-cal__nav" data-step="-1"' + (atMin ? ' disabled' : '') + '>&#8249;</button>'
      +     '<div class="rms-cal__title">' + MONTHS[this.month-1] + ' ' + this.year + '</div>'
      +     '<button class="rms-cal__nav" data-step="1">&#8250;</button>'
      +   '</div>';

    if (this.loading) {
      html += '<div class="rms-cal__state">Loading availability&hellip;</div>';
    } else if (this.error) {
      html += '<div class="rms-cal__state">Couldn’t load availability</div>';
    } else {
      html += '<div class="rms-cal__grid">';
      DOW.forEach(function (d) { html += '<div class="rms-cal__dow">' + d + '</div>'; });
      var startPad = new Date(this.year, this.month - 1, 1).getDay();
      var daysIn   = new Date(this.year, this.month, 0).getDate();
      var todayStr = new Date().toISOString().slice(0, 10);
      var minSelectableISO = '';
      if (this.minLeadDays > 0) {
        var min = new Date();
        min.setHours(0, 0, 0, 0);
        min.setDate(min.getDate() + this.minLeadDays);
        minSelectableISO = min.getFullYear() + '-'
          + String(min.getMonth() + 1).padStart(2, '0') + '-'
          + String(min.getDate()).padStart(2, '0');
      }
      for (var i = 0; i < startPad; i++) html += '<div class="rms-cal__day rms-cal__day--other"></div>';
      for (var d = 1; d <= daysIn; d++) {
        var iso = this.year + '-' + String(this.month).padStart(2,'0') + '-' + String(d).padStart(2,'0');
        var cls = 'rms-cal__day';
        var clickable = false;
        var tooSoon = !!(minSelectableISO && iso < minSelectableISO);
        if (iso < todayStr || tooSoon)            cls += ' rms-cal__day--unavailable';
        else if (data && data[iso] === true)    { cls += ' rms-cal__day--available'; clickable = true; }
        else if (data && data[iso] === false)     cls += ' rms-cal__day--unavailable';
        if (iso === this.selected)                cls += ' rms-cal__day--selected';
        var attrs = clickable ? ' data-iso="' + iso + '"' : '';
        html += '<div class="' + cls + '"' + attrs + '>' + d + '</div>';
      }
      html += '</div>'
            + '<div class="rms-cal__legend">'
            +   '<span><span class="rms-cal__dot" style="background:rgba(31,157,85,.35)"></span>Available</span>'
            +   '<span><span class="rms-cal__dot" style="background:#e5e5e5"></span>Unavailable</span>'
            + '</div>';
    }
    html += '</div>';
    this.el.innerHTML = html;

    [].forEach.call(this.el.querySelectorAll("[data-step]"), function (btn) {
      btn.addEventListener("click", function () {
        self.step(parseInt(btn.getAttribute("data-step"), 10));
      });
    });

    [].forEach.call(this.el.querySelectorAll("[data-iso]"), function (cell) {
      cell.addEventListener("click", function () {
        self.selectDate(cell.getAttribute("data-iso"));
      });
    });
  };

  Calendar.prototype.selectDate = function (iso) {
    this.selected = iso;
    this.render();
    this.el.dispatchEvent(new CustomEvent("rms-availability:select", {
      detail: { date: iso },
      bubbles: true
    }));
  };

  function mount(el) {
    if (el.getAttribute("data-rms-mounted")) return;
    el.setAttribute("data-rms-mounted", "1");
    el.innerHTML = '<div class="rms-cal"><div class="rms-cal__state">Loading availability&hellip;</div></div>';
    resolveItemId(el)
      .then(function (id) { el.__rmsCal = new Calendar(el, id); })
      .catch(function (err) {
        el.innerHTML = '<div class="rms-cal"><div class="rms-cal__state">'
          + 'Availability unavailable</div></div>';
        if (window.console) console.warn("[rms-availability]", err.message);
      });
  }

  function refreshForSizeChange() {
    [].forEach.call(
      document.querySelectorAll("#rms-availability, .rms-availability"),
      function (el) {
        if (!el.__rmsCal) return;
        resolveItemId(el)
          .then(function (id) { el.__rmsCal.setItemId(id); })
          .catch(function (err) {
            if (window.console) console.warn("[rms-availability] size refresh failed", err.message);
          });
      }
    );
  }

  function bindSizeListener() {
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || t.tagName !== "SELECT") return;
      if (t.classList.contains("bq-variation") || t.name === "variation") {
        refreshForSizeChange();
      }
    });
  }

  function init() {
    injectStyle();
    bindSizeListener();
    [].forEach.call(
      document.querySelectorAll("#rms-availability, .rms-availability"),
      mount
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
